import type { Locale } from "@/lib/i18n";
import { pl, type WPrezentationTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wPrezentationTranslations: Record<Locale, WPrezentationTranslations> = {
  pl,
  en,
  de,
};

export type { WPrezentationTranslations };
